import styled from "styled-components";

export const OutcomesTabs = styled.div`
  display: flex;
  background-color: #E9E9F5;
  border-radius: 56.43px;
  padding: 5px;
  .tab-box {
    border-radius: 20.15px;
    display: flex;
    padding: 5px 10px;
    align-items: center;
    font-family: "Nunito Sans";
    box-sizing: border-box;
    cursor: pointer;
    &__icon {
      margin-right: 10px;
      font-size: 13px;
      color: #1F1F52;
      &--selected {
        font-size: 20px;
      }
    }
    &__name {
      margin-right: 10px;
      color: #1F1F52;
      font-size: 17px;
    }
    &__info-icon {
      color: #1F1F52;
      font-size: 13px;
    }
    &--selected {
      padding: 5px 20px;
      font-family: "Nunito Sans Bold";
      background-color: #FFFFFF;
      box-shadow: 0px 0px 4.03px 0px #37358F2B;
    }
  }
`

export const TabDescription = styled.div`
  background: var(--white);
  box-shadow: 0px 3px 6px ${({theme}) => theme.blackShadow}29;
  border-radius: 5px;
  max-width: 200px;
  padding: 5px 10px;
  font-family: "Nunito Sans Light";
  font-size: 12px;
`

